module.exports = __webpack_public_path__ + "static/media/pic1.4f10bc4b.webp";